<div>
  <p [style.width.%]="data" style="margin-top:2%;" attr.data-value={{data}}></p>
  <progress max="100" attr.value={{data}} class="progress"></progress>
</div>
